module.exports = __webpack_public_path__ + "static/media/1.29e3c965.jpg";